import {createAction} from '@reduxjs/toolkit'
import {START_EDIT, STOP_EDIT} from './constants'

export const affiliationsStartEdit = createAction<unknown>(START_EDIT)
export const affiliationsStopEdit = createAction(STOP_EDIT)
